export const REQUEST_CANCELLING_CONSTANTS = {
    SEARCH_API: "SEARCH_API",
    PRESS_RELEASE_FEEDS_API: "PRESS_RELEASE_FEEDS_API",
    PRINT_ONLINE_FEEDS_API: "PRINT_ONLINE_FEEDS_API",
};
